import { render, staticRenderFns } from "./SoftwareCategoryChoosePlan.vue?vue&type=template&id=ae5d945e"
import script from "./SoftwareCategoryChoosePlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./SoftwareCategoryChoosePlan.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../../work/modules/node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSectionTitle: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiSectionTitle.vue').default,UiButton: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/PRESTIGIO-SOLUTIONS/PRESTIGIO-SOLUTIONS_Deploy_Prod/components/ui/UiButton.vue').default})
